import { MaterialDesignContent } from "notistack";
import { styled } from "@mui/material/styles";

// 1. Create a styled component to override the internal styles
const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  "&.notistack-MuiContent": {
    // Apply your custom styles here
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[3], // Your shadow
    border: "none", // Your removed border
    borderRadius: "8px", // Optional rounded corners
    fontWeight: "bold",
  },
  // You can target specific variants if needed
  "&.notistack-MuiContent-success": {
    backgroundColor: "#edf7ed", // Example light green bg
    color: "#1e4620",
  },
  "&.notistack-MuiContent-error": {
    backgroundColor: "#fdeded",
    color: "#5f2120",
  },
}));

export default StyledMaterialDesignContent;
